import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({
    name: 'sanitizeUrl',
    pure: false
})
export class SafeUrl implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) {
    }

    transform(value: string, args?: any): any {     
        console.log('herewr')       
        return this.domSanitizer.bypassSecurityTrustResourceUrl(value);
    }
}